import { Layout } from "@/components/layout/Layout";
import { Link } from "wouter";
import { ChevronRight } from "lucide-react";

export default function CookiesPage() {
  return (
    <Layout>
      <div className="container py-8 md:py-12">
        {/* Breadcrumbs */}
        <div className="flex items-center text-sm text-muted-foreground mb-8">
          <Link href="/">
            <span className="hover:text-primary cursor-pointer">Home</span>
          </Link>
          <ChevronRight className="h-4 w-4 mx-2" />
          <span>Cookie Policy</span>
        </div>
        
        {/* Page Content */}
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
          
          <div className="prose max-w-none">
            <p className="text-muted-foreground">Last updated: April 27, 2025</p>
            
            <h2>1. Introduction</h2>
            <p>
              This Cookie Policy explains how StayMiddle ("we", "us", or "our") uses cookies and similar technologies to recognize you when you visit our website and use our services. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
            </p>
            
            <h2>2. What Are Cookies?</h2>
            <p>
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.
            </p>
            <p>
              Cookies set by the website owner (in this case, StayMiddle) are called "first-party cookies". Cookies set by parties other than the website owner are called "third-party cookies". Third-party cookies enable third-party features or functionality to be provided on or through the website (e.g., advertising, interactive content, and analytics).
            </p>
            
            <h2>3. Why Do We Use Cookies?</h2>
            <p>
              We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons for our website to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies enable us to track and target the interests of our users to enhance the experience on our website. Third parties serve cookies through our website for advertising, analytics, and other purposes.
            </p>
            
            <h2>4. Types of Cookies We Use</h2>
            <p>
              The specific types of first and third-party cookies served through our website and the purposes they perform include:
            </p>
            
            <h3>4.1. Essential Cookies</h3>
            <p>
              These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas. Because these cookies are strictly necessary to deliver the website, you cannot refuse them without impacting how our website functions.
            </p>
            
            <h3>4.2. Performance and Functionality Cookies</h3>
            <p>
              These cookies are used to enhance the performance and functionality of our website but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.
            </p>
            
            <h3>4.3. Analytics and Customization Cookies</h3>
            <p>
              These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, or to help us customize our website for you.
            </p>
            
            <h3>4.4. Advertising Cookies</h3>
            <p>
              These cookies are used to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed, and in some cases selecting advertisements that are based on your interests.
            </p>
            
            <h3>4.5. Social Media Cookies</h3>
            <p>
              These cookies are used to enable you to share pages and content that you find interesting on our website through third-party social networking and other websites. These cookies may also be used for advertising purposes.
            </p>
            
            <h2>5. How Can You Control Cookies?</h2>
            <p>
              You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by following the directions provided in our cookie banner or in your browser settings.
            </p>
            <p>
              Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of our website.
            </p>
            
            <h2>6. Updates to This Cookie Policy</h2>
            <p>
              We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
            </p>
            <p>
              The date at the top of this Cookie Policy indicates when it was last updated.
            </p>
            
            <h2>7. More Information</h2>
            <p>
              If you have any questions about our use of cookies or other technologies, please email us at <a href="mailto:privacy@staymiddle.com" className="text-primary hover:underline">privacy@staymiddle.com</a>.
            </p>
            
            <p className="mt-8">
              For more information about our privacy practices, please review our <Link href="/privacy"><span className="text-primary hover:underline">Privacy Policy</span></Link>.
            </p>
            <p>
              For more information about our terms of use, please review our <Link href="/terms"><span className="text-primary hover:underline">Terms of Use</span></Link>.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}